import * as fromDatatype from "../../../../models/datatype-library";

export class DepositRequisitionSearchCriteriaDtoModel {
  limit: number;
  orderBy: string|boolean;
  order: string;
  
  keyword_search?: string;
  guids?: string [];
  server_doc_types?: string [];
  category_guids?: string [];
  comp_guids?: string [];
  server_doc_no?: string;
  created_date_from?: fromDatatype.TimestampTzDatatypeInterface;
  created_date_to?: fromDatatype.TimestampTzDatatypeInterface;
  deposit_start_date_from?: fromDatatype.TimestampTzDatatypeInterface;
  deposit_start_date_to?: fromDatatype.TimestampTzDatatypeInterface;
  maturity_end_date_from?: fromDatatype.TimestampTzDatatypeInterface;
  maturity_end_date_to?: fromDatatype.TimestampTzDatatypeInterface;
  deposit_amount_from?: fromDatatype.NumericDatatypeInterface;
  deposit_amount_to?: fromDatatype.NumericDatatypeInterface;
  maturity_amount_from?: fromDatatype.NumericDatatypeInterface;
  maturity_amount_to?: fromDatatype.NumericDatatypeInterface;
  term_from?: fromDatatype.VarcharDatatypeInterface;
  term_to?: fromDatatype.VarcharDatatypeInterface;    
  interest_rate_from?: fromDatatype.NumericDatatypeInterface;
  interest_rate_to?: fromDatatype.NumericDatatypeInterface;
  est_interest_amount_from?: fromDatatype.NumericDatatypeInterface;
  est_interest_amount_to?: fromDatatype.NumericDatatypeInterface;
  actual_interest_amount_from?: fromDatatype.NumericDatatypeInterface;
  actual_interest_amount_to?: fromDatatype.NumericDatatypeInterface;
  auto_rollover_logics?: string [];
  term_types?: string [];
  currencies?: string [];
  process_status_guids?: string [];
  process_hdr_guids?: string [];
  interest_types?: string [];
  calcTotalRecords?: boolean;
  status: string;
  posting_status: string;
}
  